import axios from "axios";
import ApiService from "@/services/ApiService.js";

export const state = {
  listLogs:[],
  resultLogs:[],
};
export const mutations = {
  GET_LOGS({ context }, logs) {
    state.listLogs = Object.assign({}, logs);
  },

  // CONSULTAR_LOGS({ context }, logs) {
  //   // state.loading = false;
  //   // // state.resultCedula = Object.assign({}, result_cedulas);
  //   // if (logs) {
  //   //   let logs = [];
  //   //   Object.entries(result_logs).forEach(([key, val]) => logs.push(val));
  //   //   return (state.resultLogs = logs);
  //     state.resultLogs = Object.assign({}, logs);
  //   // }
  // },

};
export const actions = {
  // GET_LOGS({ commit }, data) { //axios, mandar parametros para post
  //   return new Promise((resolve, reject) => {
  //     commit("SET_LOADING", true);
  //     ApiService.get(data)
  //       .then(response => {
  //         //console.log("store",response);
  //         commit("SET_LOADING", false);
  //         commit("GET_LOGS", response);//mandar a mutations
  //         resolve(response);
  //       })
  //       .catch(error => {
  //         commit("SET_LOADING", false);
  //         reject(error);
  //       });
  //   });
  // },

    GET_LOGS({ commit }, data) { //axios, mandar parametros para post
      return new Promise((resolve, reject) => {
        commit("SET_LOADING", true);
        ApiService.get(data)
          .then(response => {
            //console.log("store",response);
            commit("SET_LOADING", false);
            commit("GET_LOGS", response.data.logs);//mandar a mutations
            resolve(response);
          })
          .catch(error => {
            commit("SET_LOADING", false);
            reject(error);
          });
      });
    },
};
export const getters = {//leer datos
  listLogs: state => state.listLogs,
  //resultLogs: state => state.resultLogs
};
